import { Injectable } from '@angular/core';
import { FieldInfo, FieldInfoRegistry } from './field-info.types';

@Injectable({ providedIn: 'root' })
export class FieldInfoService {
  private registry: FieldInfoRegistry = {};

  register(entries: FieldInfoRegistry): void {
    this.registry = { ...this.registry, ...entries };
  }

  get(key: string): FieldInfo | undefined {
    return this.registry[key];
  }

  has(key: string): boolean {
    return key in this.registry;
  }
}
